import { render } from "./TrainingCreationForm.vue?vue&type=template&id=f6e5c680"
import script from "./TrainingCreationForm.vue?vue&type=script&lang=js"
export * from "./TrainingCreationForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__